/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Withdraw_FinalInputs */

const en_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm withdrawal`)
};

const de_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerruf bestätigen`)
};

const fr_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer la rétractation`)
};

const es_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar desistimiento`)
};

const it_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma recesso`)
};

const nl_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herroeping bevestigen`)
};

const pl_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź odstąpienie`)
};

const fi_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista peruuttaminen`)
};

const da_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft fortrydelse`)
};

const sv_consumer_declaration_withdraw_final = /** @type {(inputs: Consumer_Declaration_Withdraw_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekräfta frånträde`)
};

/**
* | output |
* | --- |
* | "Confirm withdrawal" |
*
* @param {Consumer_Declaration_Withdraw_FinalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_withdraw_final = /** @type {((inputs?: Consumer_Declaration_Withdraw_FinalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Withdraw_FinalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_withdraw_final(inputs)
	if (locale === "fr") return fr_consumer_declaration_withdraw_final(inputs)
	if (locale === "es") return es_consumer_declaration_withdraw_final(inputs)
	if (locale === "it") return it_consumer_declaration_withdraw_final(inputs)
	if (locale === "nl") return nl_consumer_declaration_withdraw_final(inputs)
	if (locale === "pl") return pl_consumer_declaration_withdraw_final(inputs)
	if (locale === "fi") return fi_consumer_declaration_withdraw_final(inputs)
	if (locale === "da") return da_consumer_declaration_withdraw_final(inputs)
	if (locale === "sv") return sv_consumer_declaration_withdraw_final(inputs)
	return en_consumer_declaration_withdraw_final(inputs)
});